import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Shippers" hint="Verification queue, ratings, doc review." /> }
